import React from 'react';
import { FadeIn } from './FadeIn';
import { Check, X } from 'lucide-react';
export function AudienceSection() {
  const forWho = ['Profesionales con altos niveles de responsabilidad y carga mental.', "Personas que sufren de 'cerebro eléctrico' justo al apagar la luz.", 'Mentes ansiosas que repiten conversaciones pasadas en bucle.', 'Emprendedores y creativos que no logran separar el trabajo del descanso.'];
  const notForWho = ['Personas que buscan terapia psicológica profunda (esto es una herramienta operativa).', 'Quienes esperan una solución mágica sin estar dispuestos a escribir 5 minutos.', 'Casos de insomnio médico severo que requieran intervención clínica.'];
  return <section className="py-24 bg-stone-900 px-4 sm:px-6 lg:px-8" data-id="element-13">
      <div className="max-w-6xl mx-auto" data-id="element-14">
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12" data-id="element-15">
          {/* Para quién es */}
          <FadeIn direction="right" data-id="element-16">
            <div className="bg-stone-950/50 border border-stone-800 rounded-3xl p-8 h-full" data-id="element-17">
              <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-18">
                <div className="w-10 h-10 rounded-full bg-emerald-500/10 flex items-center justify-center" data-id="element-19">
                  <Check className="w-5 h-5 text-emerald-500" data-id="element-20" />
                </div>
                Para quién ES
              </h3>
              <ul className="space-y-6" data-id="element-21">
                {forWho.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-22">
                    <Check className="w-5 h-5 text-emerald-500 shrink-0 mt-1" data-id="element-23" />
                    <span className="text-stone-300 leading-relaxed" data-id="element-24">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Para quién NO es */}
          <FadeIn direction="left" delay={0.2} data-id="element-25">
            <div className="bg-stone-950/50 border border-stone-800 rounded-3xl p-8 h-full" data-id="element-26">
              <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-27">
                <div className="w-10 h-10 rounded-full bg-rose-500/10 flex items-center justify-center" data-id="element-28">
                  <X className="w-5 h-5 text-rose-500" data-id="element-29" />
                </div>
                Para quién NO es
              </h3>
              <ul className="space-y-6" data-id="element-30">
                {notForWho.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-31">
                    <X className="w-5 h-5 text-rose-500 shrink-0 mt-1" data-id="element-32" />
                    <span className="text-stone-400 leading-relaxed" data-id="element-33">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}